import { AxiosInstance } from 'axios'
import { DictionaryDefinitionDto } from '@/types/komga-dictionary'

const API_DICTIONARY = '/api/v1/dictionary'

export default class KomgaDictionaryService {
  private http: AxiosInstance

  constructor(http: AxiosInstance) {
    this.http = http
  }

  async define(term: string, lang?: string): Promise<DictionaryDefinitionDto> {
    try {
      return (await this.http.get(`${API_DICTIONARY}/define`, { params: { term, lang } })).data
    } catch (e) {
      let msg = `An error occurred while trying to define '${term}'`
      if (e?.response?.data?.message) {
        msg += `: ${e.response.data.message}`
      }
      throw new Error(msg)
    }
  }
}

